import { type Purpose, useDeletePurposeMutation } from 'prove-common'
import { PurposeForm } from '../../components/reference-data/ReferenceEntityForms'
import { ReferenceTable } from '../reference-table/ReferenceTable'

type PurposesTableProps = {
  purposes: Purpose[]
}

export const PurposesTable = ({ purposes }: PurposesTableProps) => {
  const deletePurpose = useDeletePurposeMutation()
  return (
    <ReferenceTable
      rows={purposes}
      title='Hensikter'
      emptyTitle='Ingen hensikter'
      columns={[
        { key: 'name', label: 'Navn', value: (row) => row.name },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => row.name}
      protectedReason={(row) =>
        row.name === 'OK-program'
          ? 'Systemhensikt: kan ikke endres eller slettes.'
          : undefined
      }
      editForm={(row, close) => <PurposeForm purpose={row} onClose={close} />}
      onDelete={(id) => deletePurpose.mutateAsync(id)}
    />
  )
}
